module.exports = __webpack_public_path__ + "static/media/facet-water-fire-icon.eb56de43.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/facet-water-fire-icon.png
// module id = 1258
// module chunks = 0